module.exports = __webpack_public_path__ + "img/trophy-fireworks.f8a5b692.png";